import React from 'react';
import styled from 'styled-components';

const PFSAdd = ({ onClose }) => {
  return (
    <FormPanel>
      <FormHeader>
        <Title>Project Fund Source Form</Title>
        <Icons>
          <CloseBtn onClick={onClose}>✖</CloseBtn>
        </Icons>
      </FormHeader>

      <FormBody>
        <Row>
          <Field>
            <Label>Fund Source</Label>
            <Input placeholder="e.g. DA-RFO, NIA, LGU" />
          </Field>
          <Field>
            <Label>Fund Year</Label>
            <Input placeholder="e.g. 2023" />
          </Field>
        </Row>

        <Row>
          <Field>
            <Label>Fund Amount</Label>
            <Input placeholder="e.g. ₱5,000,000" />
          </Field>
          <Field>
            <Label>Date Started</Label>
            <Input type="date" />
          </Field>
        </Row>

        <Row>
          <Field>
            <Label>Date Completed</Label>
            <Input type="date" />
          </Field>
          <Field>
            <Label>Turnover Date</Label>
            <Input type="date" />
          </Field>
        </Row>
      </FormBody>

      <FormFooter>
        <AddButton>Add</AddButton>
      </FormFooter>
    </FormPanel>
  );
};

export default PFSAdd;

const FormPanel = styled.div`
  width: 700px;
  max-height: 90vh;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  font-family: 'Segoe UI', sans-serif;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const FormHeader = styled.div`
  background-color: #2e7d32;
  color: white;
  padding: 5px 20px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.h3`
  margin: 0;
  font-size: 16px;
`;

const Icons = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const CloseBtn = styled.button`
  background: none;
  color: white;
  font-size: 20px;
  border: none;
  cursor: pointer;

  &:hover {
    color: #ffdede;
  }
`;

const FormBody = styled.div`
  padding: 10px 20px 20px;
  overflow-y: auto;
  flex-grow: 1;
`;

const FormFooter = styled.div`
  padding: 15px 20px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  background-color: #f9f9f9;
`;

const AddButton = styled.button`
  padding: 10px 20px;
  background-color: #2e7d32;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    background-color: #27672a;
  }
`;

const Row = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 15px;

  & > div {
    flex: 1;
  }
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  font-size: 13px;
  margin-bottom: 4px;
  color: #555;
`;

const Input = styled.input`
  padding: 10px;
  font-size: 14px;
  border-radius: 6px;
  border: 1px solid #ccc;

  &:focus {
    outline: none;
    border-color: #4caf50;
    box-shadow: 0 0 4px rgba(76, 175, 80, 0.3);
  }
`;
